document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".accordion__trigger");

  if (triggers) {
    triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const expanded = trigger.getAttribute("aria-expanded") === "true";
      trigger.setAttribute("aria-expanded", !expanded);

      const content = trigger.nextElementSibling;
      if (!expanded) {
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = null;
      }
    });
  });
  }
});